module.exports = __webpack_public_path__ + "static/img/quality01.a5f1f01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quality01.jpg
// module id = Knj/
// module chunks = 1